<template lang="pug">
v-app
  v-app-bar.re-app-bar(app :height="$vuetify.breakpoint.mdAndUp ? 70 : 60")
    v-container.d-flex.align-center
      v-btn(icon @click="$router.push('/kkm')")
        v-icon mdi-arrow-left
      v-toolbar-title {{ $t("позиции_чека") }}

  v-main.mb-8(flat)
    re-ticket-details-main(ref="ticketDetailsMainRef")

</template>
<script>
import { mapActions } from 'vuex'
import TicketDetailsMain from './parts/TicketDetailsMain.vue'

export default {
  components: {
    're-ticket-details-main': TicketDetailsMain,
  },

  methods: {
    ...mapActions({
      setTicketRequest: 'cashRegisters/setTicketRequest',
      showConfirm: 'confirm/showConfirm',
    }),
  },

  beforeRouteLeave(to, from, next) {
    this.$refs.ticketDetailsMainRef.closeDialogsOrExit(to, next)
  },
}
</script>

<style lang="stylus" scoped>

</style>
